import loadable from '@loadable/component';
export const SignupPage=loadable(() => import('./SignupPage'));
